import { useEffect, useState } from "react";
import { CustomerData, LedgerDetails } from "src/shared/services/interfacev2";
import { getLedgerByCustomer } from "src/shared/services/servicesv2";

export const useLedger = (customer: CustomerData | null) => {
  const [ledger, setLedger] = useState<LedgerDetails | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!customer?._id?.$oid) return;

    setLoading(true);

    getLedgerByCustomer(customer._id.$oid)
      .then((res) => {
        setLedger(res.data.ledger); // ✅ API already returns LedgerDetails
      })
      .catch(() => {
        // ✅ fallback with CORRECT SHAPE
        setLedger({
          orgId: 0,
          refId: 0,
          totalOutstandingBalance: 0,
          customerDetails: {
            firstName: "",
            middleName: "",
            lastName: "",
            phones: [],
            emails: [],
            refId: 0
          },
          orderDetails: [],
          orderHistory: [],
        });
      })
      .finally(() => setLoading(false));
  }, [customer]);

  return { ledger, loading };
};
